import { jsx as c } from "react/jsx-runtime";
import { titleLvlMap as d } from "./index70.js";
import "react";
import "axios";
import { isString as v } from "./index71.js";
import { isEmpty as g } from "./index72.js";
import { parseClassNames as h } from "./index73.js";
import { safeHtmlParse as x } from "./index74.js";
const C = ({
  titleLevel: r,
  children: t,
  renderAs: o = "p",
  strong: i = !1,
  tiny: e = !1,
  light: m = !1,
  note: a = !1,
  className: n,
  color: p,
  ...l
}) => {
  const f = d[r || "none"], s = h([
    f,
    n,
    e ? "tiny" : void 0,
    m ? "light" : void 0,
    i ? "strong" : void 0,
    a ? "note" : void 0,
    p
  ]);
  return /* @__PURE__ */ c(
    o === "span" ? "span" : "p",
    {
      ...l,
      ...g(s) ? {} : { className: s },
      children: v(t) ? x(t) : t
    }
  );
};
export {
  C as Text
};
